module.exports = __webpack_public_path__ + "img/loupe.d6f51321.png";